const PROCESS_START = 'PROCESS_START'
const PROCESS_END = 'PROCESS_END'

export { PROCESS_START, PROCESS_END }
